import { reactive } from 'vue';
import { watchOnce } from '@vueuse/core';

import { isFeatureToggleActive } from '../customFeatureToggles';

export type StatsigExperimentName =
  | 'simplified_mobile_summary'
  | 'hotel_details_room_cards_grid_layout'
  | 'calendar_without_prices_in_car_trip'
  | 'new_book_type_button'
  | 'to_meta_hotel_card'
  | 'mobile_flight_header'
  | 'more_dates_and_prices_copy_in_hotel_selection'
  | 'optimized_flight_addition_in_transport_banner'
  | 'date_location_segment_desktop';

interface StatsigExperimentState {
  value: boolean;
  isLoaded: boolean;
}

type StatsigExperiments = Record<StatsigExperimentName, StatsigExperimentState>;

const statsigExperiments = reactive<StatsigExperiments>({
  simplified_mobile_summary: { value: false, isLoaded: false },
  hotel_details_room_cards_grid_layout: { value: false, isLoaded: false },
  calendar_without_prices_in_car_trip: { value: false, isLoaded: false },
  new_book_type_button: { value: false, isLoaded: false },
  to_meta_hotel_card: { value: false, isLoaded: false },
  mobile_flight_header: { value: false, isLoaded: false },
  more_dates_and_prices_copy_in_hotel_selection: {
    value: false,
    isLoaded: false,
  },
  optimized_flight_addition_in_transport_banner: {
    value: false,
    isLoaded: false,
  },
  date_location_segment_desktop: {
    value: false,
    isLoaded: false,
  },
});

export function assignExperimentValue(
  experimentName: StatsigExperimentName,
  value: boolean
): void {
  statsigExperiments[experimentName].value = value;
  statsigExperiments[experimentName].isLoaded = true;
}

export async function isExperimentAsync(
  experimentName: StatsigExperimentName
): Promise<boolean> {
  return new Promise((resolve) => {
    if (isFeatureToggleActive(experimentName)) {
      resolve(true);
    } else if (isFeatureToggleActive(`!${experimentName}`)) {
      resolve(false);
    } else if (statsigExperiments[experimentName].isLoaded) {
      resolve(statsigExperiments[experimentName].value);
    } else {
      watchOnce(
        () => statsigExperiments[experimentName].isLoaded,
        async () => resolve(statsigExperiments[experimentName].value)
      );
    }
  });
}
